import { SigninRedirectArgs, SignoutRedirectArgs } from 'oidc-client-ts'
import { userManager } from './oidcConfig'

export const signinRedirect = (params?: SigninRedirectArgs) => userManager.signinRedirect(params)

export const signoutRedirect = (params?: SignoutRedirectArgs) => userManager.signoutRedirect(params)

export const completeSignin = () => userManager.signinRedirectCallback()

export const getUser = () => userManager.getUser()

export const removeUser = () => userManager.removeUser()
